

















































































































































































































































































































































































import ProposalProgress from '@/modules/direct-sales/components/proposal-progress/proposal-progress.vue';
import { DIRECT_SALES_ROUTES } from '@/modules/direct-sales/router';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ActionBar from '@/components/action-bar/action-bar.vue';
import KendoChart from '@/components/kendo-chart/kendo-chart.vue';
import { numeralService, stringService, httpService } from '@/services';
import _ from 'lodash';
import moment from 'moment';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { AxiosError, AxiosResponse } from 'axios';
import { CONFIG } from '@/config';
import PageLoader from '@/components/page-loader/page-loader.vue';
import { Http } from '@/decorators';
import { Size } from '@/enums';
import { notificationService } from '@/services';
import { ImodelsSelected } from '@/modules/direct-sales/Interfaces/index';
import KendoDropdown from '@/components/kendo-dropdown/kendo-dropdown.vue';

@Component({
  subscriptions() {
    return {
      searchValue$: this.$watchAsObservable('state.searchValue').pipe(
        pluck('newValue'),
        debounceTime(400),
        distinctUntilChanged(),
        startWith('')
      )
    };
  },
  components: {
    ActionBar,
    KendoChart,
    ProposalProgress,
    PageLoader,
    KendoDropdown
  }
})
export default class DirectSalesProposalsCompletePage extends Vue {
  @Prop({ required: false })
  proposalId: number;

  @Prop({ required: true })
  consumerId: number;

  public getMax = numeralService.getMax;
  public getMin = numeralService.getMin;
  public searchValue$: string;

  public state: any = {
    data: [],
    consumer: {},
    searchValue: '',
    familyColumnOrder: 'familyName',
    familyStatus: -1,
    selectedFamily: 0,
    selectedStore: 0,
    selectedRegion: 0,
    modelSelected: 0,
    colorSelected: 0,
    familyModel: 0,
    familyColor: 0,
    currentDate: moment()
      .startOf('month')
      .toDate(),
    favoritedOnly: false,
    areaDemarcatedStore: true,
    isContactedAutomaker: false,
    stores: [{ value: 0, text: 'Selecione' }],
    storesDelivery: [],
    typesRegions: [{ value: 0, text: 'Selecione' }],
    typesTaxRegions: [{ value: 0, text: 'Selecione' }],
    proposalVehiclesCopy: {},
    storeDelivery: {}
  };

  public modelSelected: any;

  public familyColumnOrderDataSource = [
    {
      text: 'Familia',
      value: 'familyName'
    },
    {
      text: 'Modelo',
      value: 'modelName'
    },
    {
      text: 'Cor',
      value: 'color'
    },
    {
      text: 'QTD',
      value: 'unitsTotal'
    }
  ];

  public selectStoreDelivery(store: any) {
    this.state.storeDelivery = store;
  }

  public selectStoreSales(idStore: any) {
    this.state.areaDemarcatedStore = true;

    this.state.selectedStore = idStore;

    this.state.store = _(this.state.stores)
      .filter((f: any) => f.value == idStore)
      .value()[0];

    this.state.isContactedAutomaker = false;

    if (idStore != 0) {
      httpService.http
        .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/checkDemarcatedArea/${this.consumerId}/${idStore}/`)
        .then((res: AxiosResponse) => {
          this.state.areaDemarcatedStore = res.data;
        })
        .catch((err: AxiosError) => console.log(err.message));
    }
  }

  public selectRegionType(idRegionType: any) {
    this.state.selectedRegion = idRegionType;
    if (this.state.selectedRegion == 0) {
      this.state.typeTaxRegion = 0;
      return;
    }
    this.getTypeTaxRegion();
  }

  public selectTaxRegionType(idTaxRegion: any) {
    this.state.typeTaxRegion = idTaxRegion;

    if (this.state.typeTaxRegion == 0) {
      return;
    }

    this.getAvailabilityVehicle();
  }

  public calTotal(forecast) {
    return this.formatNumber(
      _.sum([
        ..._(forecast)
          .map((s: any) => (s.totalSelected && !isNaN(s.totalSelected) && s.totalSelected > 0 ? s.totalSelected : 0))
          .value()
      ])
        ? _.sum([
            ..._(forecast)
              .map((s: any) =>
                s.totalSelected && !isNaN(s.totalSelected) && s.totalSelected > 0 ? s.totalSelected : 0
              )
              .value()
          ])
        : 0
    );
  }

  public get stockListFilterFamily() {
    return _(this.state.data)
      .filter((item: any) => {
        if (this.state.selectedFamily === 0) {
          return _.some(item.forecast, (item: any) => {
            return item.totalSelected > 0;
          });
        } else if (item.idFamily === this.state.selectedFamily) {
          return true;
        }
        return false;
      })
      .filter((item: any) =>
        _.size(this.searchValue$)
          ? _.some(['familyName', 'modelName', 'color'], p =>
              stringService.normalize(item[p]).includes(stringService.normalize(this.searchValue$))
            )
          : true
      )
      .value();
  }

  public get stockList() {
    return _(this.stockListFilterFamily)
      .filter((item: any) => {
        if (this.state.modelSelected === 0) {
          return true;
        } else if (item.idModel === this.state.modelSelected) {
          return true;
        }
        return false;
      })
      .filter((item: any) => {
        if (this.state.colorSelected === 0) {
          return true;
        } else if (item.idColor === this.state.colorSelected) {
          return true;
        }
        return false;
      })
      .orderBy((item: any) => {
        switch (this.state.familyColumnOrder) {
          default:
            return item[this.state.familyColumnOrder];
        }
      })
      .value();
  }

  public goToFamily() {
    var selectedfamily = _.filter(this.productFamilies, (f: any) => f.value == this.state.selectedFamily)[0];

    var index = this.productFamilies.indexOf(selectedfamily) + 1;

    if (this.productFamilies && this.productFamilies[index]) {
      this.state.selectedFamily = this.productFamilies[index].value;
    } else {
      this.state.selectedFamily = 0;
    }
  }

  public get modelVehicles() {
    if (this.state.familyModel != this.state.selectedFamily) {
      this.state.familyModel = this.state.selectedFamily;
      this.state.modelSelected = 0;
      this.state.colorSelected = 0;
    }

    //return [{ text: 'SELECIONE', value: 0 }, ...stores]
    let models = _(this.stockListFilterFamily)
      .map((d: any) => ({ text: d.modelName, value: d.idModel }))
      .uniqBy('text')
      .orderBy('value')
      .value();

    return _([{ text: 'SELECIONE', value: 0 }, ...models])
      .orderBy('text')
      .value();
  }

  public get colorVehicles() {
    if (this.state.familyColor != this.state.selectedFamily) {
      this.state.familyColor = this.state.selectedFamily;
      this.state.colorSelected = 0;
    }

    let colors = _(this.stockListFilterFamily)
      .filter((item: any) => {
        if (this.state.modelSelected === 0) {
          return true;
        } else if (item.idModel === this.state.modelSelected) {
          return true;
        }
        return false;
      })
      .map((d: any) => ({ text: d.color, value: d.idColor }))
      .uniqBy('text')
      .orderBy('value')
      .value();

    return _([{ text: 'SELECIONE', value: 0 }, ...colors])
      .orderBy('text')
      .value();
  }

  public get dateFilter() {
    return _([
      moment(
        moment(new Date())
          .startOf('month')
          .toDate()
      ),
      moment()
        .startOf('month')
        .add(1, 'month')
        .toDate(),
      moment()
        .startOf('month')
        .add(2, 'month')
        .toDate()
    ])
      .groupBy(item => moment(item).format('MMM/YYYY'))
      .map((values, key) => ({
        text: key,
        value: moment(values[0])
          .startOf('month')
          .toDate(),
        year: parseInt(
          moment(
            moment(values[0])
              .startOf('month')
              .toDate()
          ).format('YYYY')
        ),
        month: parseInt(
          moment(
            moment(values[0])
              .startOf('month')
              .toDate()
          ).format('M')
        )
      }))
      .orderBy(item => item.value)
      .value();
  }

  public get productFamilies() {
    const families = _(this.state.data)
      .map((d: any) => ({ text: d.familyName, value: d.idFamily }))
      .uniqBy('text')
      .orderBy('text')
      .value();

    if (!this.proposalId && families.length > 0) {
      this.state.selectedFamily = families[0].value;
    }

    return families;
  }

  public formatNumber(v: any) {
    if (v) {
      return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return 0;
  }

  public getConsumer() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/consumer/${this.consumerId}`)
      .then((res: AxiosResponse) => {
        this.state.consumer = {
          id: res.data.id,
          name: res.data.name,
          cnpj: this.formatarCampo(res.data.cpfCnpj),
          idSalesChannel: res.data.idSalesChannel,
          geocode: res.data.geocode,
          city: res.data.city,
          uf: res.data.uf,
          units: res.data.qtdPurchase,
          updatedAt: res.data.lastPurchase ? moment(res.data.lastPurchase).format('DD/MM/YYYY') : '',
          descriptionSalesChannel: res.data.descriptionSalesChannel
        };
        this.getTypeRegion();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getTypeRegion() {
    httpService.http
      .get(
        `${CONFIG.URL.NEODASH_API}/api/directsales/vehicle/typeRegion/${this.state.consumer.geocode}/${
          this.state.consumer.idSalesChannel
        }`
      )
      .then((res: AxiosResponse) => {
        this.state.typesRegions = [{ value: 0, text: 'Selecione' }, ...res.data];
        if (res.data && res.data.length == 1) {
          this.state.typeRegion = this.state.typesRegions[1];
          this.state.selectedRegion = this.state.typeRegion.value;
          this.getTypeTaxRegion();
        }
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getTypeTaxRegion() {
    httpService.http
      .get(
        `${CONFIG.URL.NEODASH_API}/api/directsales/vehicle/taxExemptionRegion/${this.state.consumer.geocode}/${
          this.state.selectedRegion
        }/${this.state.consumer.idSalesChannel}`
      )
      .then((res: AxiosResponse) => {
        this.state.typesTaxRegions = [{ value: 0, text: 'Selecione' }, ...res.data];

        if (res.data && res.data.length == 1) {
          this.state.taxRegion = this.state.typesTaxRegions[1];
          this.state.typeTaxRegion = this.state.taxRegion.value;
          this.getAvailabilityVehicle();
        }

        this.getCopyProposal();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getProposal() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/${this.proposalId}/GetProposal`)
      .then((res: AxiosResponse) => {
        this.state.proposalVehiclesCopy = res.data.proposalVehicles;
        this.state.selectedStore = res.data.idStoreSale;
        this.state.selectedRegion = res.data.proposalVehicles[0].idTypeRegionTablePrice;
        this.state.typeTaxRegion = res.data.proposalVehicles[0].idTypeTaxExemptionRegion;
        this.getAvailabilityVehicle();

        this.state.store = _(this.state.stores)
          .filter((f: any) => f.value == this.state.selectedStore)
          .value()[0];

        this.state.taxRegion = _(this.state.typesTaxRegions)
          .filter((f: any) => f.value == this.state.typeTaxRegion)
          .value()[0];

        this.state.typeRegion = _(this.state.typesRegions)
          .filter((f: any) => f.value == this.state.selectedRegion)
          .value()[0];

        this.state.selectedFamily = 0;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getAvailabilityVehicle() {
    if (!this.state.typeTaxRegion) {
      return;
    }

    httpService.http
      .get(
        `${CONFIG.URL.NEODASH_API}/api/directsales/vehicle/vehicles/${this.state.typeTaxRegion}/${this.consumerId}`
      )
      .then((res: AxiosResponse) => {
        this.state.data = _(res.data)
          .groupBy(function(f) {
            return f.idFamily + '_' + f.idModel + '_' + f.idColor + '_' + f.idPrice + '_' + f.modelName + '_' + f.color;
          })
          .map((m: any) => ({
            familyName: m[0].familyName.toUpperCase(),
            modelName: m[0].model,
            color: m[0].color,
            idColor: m[0].idColor,
            idFamily: m[0].idFamily,
            idModel: m[0].idModel,
            idPrice: m[0].idPrice,
            priceVehicle: m[0].priceVehicle,
            unitsTotal: _(m).sumBy((s: any) => s.stocks.length),
            forecast: _(this.dateFilter)
              // .filter((f: any) => m.some(function(s){ return s.yearReference == f.yearReference}))
              .orderBy((p: any) => p.month)
              .orderBy((p: any) => p.year)
              .map((d: any) => ({
                totalSelected:
                  _(this.state.proposalVehiclesCopy)
                    .filter(
                      (vc: any) =>
                        vc.expectedDeliveryYear == d.year &&
                        vc.expectedDeliveryMonth == d.month &&
                        m[0].idModel == vc.idModelVehicle &&
                        m[0].idColor == vc.idColorVehicle
                    )
                    .map((sel: any) => sel.amount)
                    .value().length > 0
                    ? _(this.state.proposalVehiclesCopy)
                        .filter(
                          (vc: any) =>
                            vc.expectedDeliveryYear == d.year &&
                            vc.expectedDeliveryMonth == d.month &&
                            m[0].idModel == vc.idModelVehicle &&
                            m[0].idColor == vc.idColorVehicle
                        )
                        .map((sel: any) => sel.amount)
                        .value()[0]
                    : 0,
                totalUnits: _(m[0].stocks)
                  .filter((f: any) => f.year == d.year && f.month == d.month)
                  .value().length,
                year: moment(d.value).format('YYYY'),
                month: moment(d.value).format('M')
              }))
              .value()
          }))
          .value();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getStoresUser() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/stores/`)
      .then((res: AxiosResponse) => {
        this.state.stores = _(res.data)
          .map(d => ({
            value: d.id,
            text: d.name
          }))
          .value();

        if (this.state.stores.length === 1) {
          this.selectStoreSales(this.state.stores[0].value);
        }
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public goBack() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS_CREATE,
      params: {
        proposalId: String(this.proposalId)
      }
    });
  }

  public gotToCompleteProposal() {
    this.modelSelected = this.VehiclesSelected();

    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS_SETUP,
      params: {
        customerId: String(this.consumerId),
        modelSelected: this.modelSelected,
        proposalId: String(this.proposalId)
      }
    });
  }

  public VehiclesSelected() {
    return _(this.state.data)
      .map((m: any) =>
        _.map(
          m.forecast,
          (f: any) =>
            <ImodelsSelected>{
              month: Number(f.month),
              idStore: this.state.selectedStore,
              idStoreDelivery: this.state.storeDelivery.value,
              totalSelected: Number(f.totalSelected),
              year: Number(f.year),
              idColor: Number(m.idColor),
              idConsumer: this.state.consumer.id,
              idSalesChannel: this.state.consumer.idSalesChannel,
              idFamily: Number(m.idFamily),
              idModel: Number(m.idModel),
              familyName: m.familyName,
              modelName: m.modelName,
              color: m.color,
              idPrice: m.idPrice,
              priceVehicle: Number(m.priceVehicle),
              isContactedAutomaker: this.state.isContactedAutomaker
            }
        )
      )
      .flatten()
      .filter((f: ImodelsSelected) => f.totalSelected > 0)
      .value();
  }

  public goBackCopy() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS
    });
  }

  public formatarCampo(cpf_cnpj) {
    if (cpf_cnpj) {
      cpf_cnpj = cpf_cnpj.replace(/(\.|\/|\-)/g, '');
      if (cpf_cnpj.length <= 11) {
        cpf_cnpj = this.mascaraCpf(cpf_cnpj);
      } else {
        cpf_cnpj = this.mascaraCnpj(cpf_cnpj);
      }
    }
    return cpf_cnpj;
  }

  public mascaraCpf(valor: string) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }

  public mascaraCnpj(valor: string) {
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
  }

  public getCopyProposal() {
    if (this.proposalId) {
      this.getProposal();
    }
  }

  public getStoresConsumers() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/stores/consumers/${this.consumerId}`)
      .then((res: AxiosResponse) => {
        this.state.storesDelivery = _(res.data)
          .map(d => ({
            value: d.id,
            text: d.name
          }))
          .value();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public mounted() {
    this.getStoresUser();
    this.getConsumer();
    this.getStoresConsumers();
  }
}
